
<script>
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  path: "/BackStage/PDIS/Login",
});
const routercy = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  path: "/BackStage/CY/Login",
});
var numss = 60; //秒,預設值
var nummm = 240; //分,預設值
var timeout = undefined;
export default {
  name: "Timeout",
  props: {},
  // components: {},
  // data: function () {
  //   //var numss = 10;
  //   return {
  //     numss,
  //     Timeout,
  //   };
  // },
  // mounted() {
  //   var self = this;
  //   // setTimeout(() => {
  //   //   alert("已登出系統");
  //   //   sessionStorage.removeItem("LoginInfo");
  //   //   sessionStorage.removeItem("Session_GovCode");
  //   //   // self.$router.push({ path: "/BackStage/PDIS/Login" });
  //   //   router.go();
  //   // }, 5000);
  // },
  methods: {
    clearDefaultTimeout() {
      console.log("取消自動登出系統,現在時間:" + new Date(Date.now()));
      const self = this;
      clearTimeout(timeout);
    },
    //PDIS自動登出
    setDefaultTime() {
      const self = this;
      // setTimeout(() => {
      console.log(
        numss * nummm + "秒後準備登出系統,現在時間:" + new Date(Date.now())
      );
      console.log(timeout + " =>timeout");
      // }, 1000);
      timeout = setTimeout(() => {
        // alert("已登出系統");
        alert("連線逾時，請重新登入");
        sessionStorage.removeItem("LoginInfo");
        sessionStorage.removeItem("Session_GovCode");
        localStorage.removeItem("fontSize");
        router.go(-1);
      }, 1000 * numss * nummm);
    },
    resetDefaultTime() {
      const self = this;
      clearTimeout(timeout);
      // setTimeout(() => {
      console.log(
        "重新計時:" +
          numss * nummm +
          "秒後準備登出系統,現在時間:" +
          new Date(Date.now())
      );
      // }, 1000);
      timeout = setTimeout(() => {
        // alert("重新:已登出系統");
        alert("連線逾時，請重新登入");
        sessionStorage.removeItem("LoginInfo");
        sessionStorage.removeItem("Session_GovCode");
        localStorage.removeItem("fontSize");
        router.go(-1);
      }, 1000 * numss * nummm);
    },
    //CY自動登出
    setCYDefaultTime() {
      const self = this;
      //  setTimeout(() => {
      console.log(
        numss * nummm + "秒後準備登出系統,現在時間:" + new Date(Date.now())
      );
      console.log(timeout + " =>timeout");
      // }, 1000);
      timeout = setTimeout(() => {
        alert("連線逾時，請重新登入");
        // alert("已登出系統");
        sessionStorage.removeItem("LoginInfo");
        sessionStorage.removeItem("Session_GovCode");
        localStorage.removeItem("fontSize");
        routercy.go(-1);
      }, 1000 * numss * nummm);
    },
    resetCYDefaultTime() {
      const self = this;
      clearTimeout(timeout);
      // setTimeout(() => {
      console.log(
        "重新計時:" +
          numss * nummm +
          "秒後準備登出系統,現在時間:" +
          new Date(Date.now())
      );
      // }, 1000);
      timeout = setTimeout(() => {
        alert("連線逾時，請重新登入");
        // alert("重新:已登出系統");
        sessionStorage.removeItem("LoginInfo");
        sessionStorage.removeItem("Session_GovCode");
        localStorage.removeItem("fontSize");
        routercy.go(-1);
      }, 1000 * numss * nummm);
    },
  },
};
</script>

